import { lazy } from 'react';
/** Открывает форму адреса исполнителя */
export const ExecutorAddressFormPageAsync = lazy(() => import('./ExecutorAddressForm/ExecutorAddressFormPage'));